<template>
  <v-row
    no-gutters
    class="Home">
    <v-container>
      <div
      class="bg-custom white--text"
        fill-height
        align-center
        justify-center
        style="font-family: Inter,sans-serif; border-radius: 6vw; aspect-ratio: 2;">
        <video id="33b2e3a8-e125-d946-d1ed-5914d598412a-video"
          autoplay="" loop="" style="background-image:url(&quot;https://cdn.prod.website-files.com/673756894ac417efeb387dda%2F69413d62021862ae279ef7bc_Cinemagraph_Video_Generation_Request_poster.0000000.jpg&quot;)" muted="" playsinline="" data-wf-ignore="true" data-object-fit="cover">
          <source src="https://cdn.prod.website-files.com/673756894ac417efeb387dda%2F69413d62021862ae279ef7bc_Cinemagraph_Video_Generation_Request_mp4.mp4" data-wf-ignore="true">
          <source src="https://cdn.prod.website-files.com/673756894ac417efeb387dda%2F69413d62021862ae279ef7bc_Cinemagraph_Video_Generation_Request_webm.webm" data-wf-ignore="true">
        </video>
        <div style="padding-top: 9rem;">
          <div class="text-h6 text-center">
            We are sorry to announce that we sunset our meeting scheduler. A new AI Meeting Assistant will arrive soon.
          </div>
        </div>
        <div class="mt-7 cta">
          <v-btn
            :href="`${externalLinks.siteHome}`"
            color="#140e2e"
            rounded
            x-large
            class="white--text capitalize--text font-weight-bold subtitle-1 elevation-0">
            <img
              src="/assets/logo/logo_48.svg"
              height="24px"
              width="24px"
              class="mr-7"/>
            <span>
              Go to Gmelius
            </span>
          </v-btn>
        </div>

      </div>
      <v-layout
        class="caption white--text mt-5"
        justify-center>
        &copy; {{ new Date().getFullYear() }} Gmelius. Less Email, More Life.
      </v-layout>
    </v-container>
  </v-row>
</template>

<script>
import { localeMixin } from '../mixins'
import { externalLinks } from '../config'

export default {
  mixins: [localeMixin],
  data () {
    return {
      isEmbedded: null,
      windowWidth: window.innerWidth,
      externalLinks
    }
  },
  watch: {
    windowWidth (newHeight, oldHeight) {
      this.isEmbedded = newHeight < 500 ? '1' : null
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.embed) {
      this.isEmbedded = this.$route.query.embed
    } else {
      this.isEmbedded = window.innerWidth < 500 ? '1' : null
    }
    window.addEventListener('resize', () => {
      this.updateScreenSize(window.innerWidth)
    })
  },
  methods: {
    installGmelius () {
      window.open(externalLinks.dashboardUrl, '_blank')
    },
    updateScreenSize (newWidth) {
      this.windowWidth = newWidth
    }
  }
}
</script>
<style lang="scss">
.Home {
  min-height:100vh;
  @media screen and (max-width: 800px) {
      background-image:none;
    }
  &__row {
    height: 100%;
    &--card {
      background-color: transparent !important;
    }
  }
}
video {
  object-fit: cover;
  z-index: -100;
  background-position: 50%;
  background-size: cover;
  width: 100%;
  height: 100%;
  margin: auto;
  position: absolute;
  inset: -100%;
}
.cta {
  flex-flow: column;
  justify-content: center;
  align-items: stretch;
  width: 19rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}
</style>
